module.exports = __webpack_public_path__ + "img/8b95f65d672143e2b8db8ca0207d5b6a-1440.cf9e6164.jpg";